export default __webpack_public_path__ + "static/media/pictogramBeaconMarketplace40.056c0517.svg";